import React from 'react'
import "../css/Patientdashboard.css"
import { useState, useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'
import Appointments from "../components/FilerAppointment"


const Appointment = () => {

    const [appointmentDetails, setAppointmentDetails] = useState([])

    const { id } = useParams();
    const PatientID = localStorage.setItem("PatientID", id);

    const userData = useSelector((state) => state.user.user);

    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;


    const sAuthToken = useSelector((state) => state.user.user.sAuthToken);

    const DemoGraphyData = useSelector((state) => state.user.demoDetails);


    useEffect(() => {

        getAppointment();

    }, []);




    const getAppointment = () => {


        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientAppointments}?PatientId=${id}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })


            .then((data) => {

                const parsedData = JSON.parse(data)
                setAppointmentDetails(parsedData)
                console.log("Appointment Data>>>>>>", parsedData);

            })
            .catch(() => {
                console.error("Error occured")

            });
    }



    const extractDate = (appointmentDate) => {
        const date = new Date(appointmentDate); // Create Date object from the string
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };




    const { todaysAppointment, mostRecentPrevious, mostRecentNext, filteredAppointments } = Appointments({
        appointmentDetails: appointmentDetails,
        isCounselor: 0,
    });
    const { todaysAppointment: counselorTodaysAppointment, mostRecentPrevious: counselorPrevAppointment, mostRecentNext: counselorNextAppointment, filteredAppointments: counselorAppointment } = Appointments({
        appointmentDetails: appointmentDetails,
        isCounselor: 1,
    });


    return (
        <>
            <div className="appointment-card">
                <div className="appointment-header">
                    <span>Appointments</span>


                </div>

                <div className="appointment-body">

                    {/* Next Appointment */}
                    <div className="appointment-box next-box">
                        <div className="appointment-tag next">NEXT</div>

                        <div className="appointment-details">
                            <div className="appointment-date">{extractDate(mostRecentNext?.AppointmentDate)}</div>
                            <div className="appointment-time">{mostRecentNext?.AppointmentTime}</div>

                        </div>


                    </div>

                    <div className="appointment-box current-box">
                        <div className="appointment-tag next">CURRENT</div>

                        <div className="appointment-details">
                            <div className="appointment-date">{extractDate(todaysAppointment?.AppointmentDate)}</div>
                            <div className="appointment-time">{todaysAppointment?.AppointmentTime}</div>

                        </div>


                    </div>

                    {/* Previous Appointment */}
                    <div className="appointment-box previous-box">
                        <div className="appointment-tag previous">PREVIOUS</div>

                        <div className="appointment-details">
                            <div className="appointment-date">{extractDate(mostRecentPrevious?.AppointmentDate)}</div>
                            <div className="appointment-provider">
                                {mostRecentPrevious?.AppointmentTime}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Appointment